module.exports = __webpack_public_path__ + "static/york_main_4-1290e540f4d8ce654190ec464272a9c0.jpg";